import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Card, CardContent, Typography, Button } from "@material-ui/core";
import axios from "axios";
import {
  useAccount,
  useConnect,
  useEnsName,
  useSignMessage,
  useNetwork,
  useSwitchNetwork,
} from "wagmi";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { Dialog, DialogContent, DialogActions } from "@material-ui/core";
import { CountdownCircleTimer } from "react-countdown-circle-timer";
import { Skeleton } from "@material-ui/lab";

const useStyles = makeStyles((theme) => ({
  container: {
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    background: "#f2f2f2", // Light gray background
  },
  countdownContainer: {
    textAlign: "center",
  },
  countdownText: {
    marginBottom: theme.spacing(2),
    color: "#333", // Dark gray text color
  },
  countdownTimer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: theme.spacing(2),
  },
  countdownCircle: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",

    margin: theme.spacing(0, 2),
  },
}));

function SeriesTwo() {
  const classes = useStyles();

  // Calculate the remaining time until August 1st, 2023
  const currentDate = new Date();
  const targetDate = new Date("2023-09-01 10:00:00");
  const remainingTime = targetDate - currentDate;

  const endOfDay = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth(),
    currentDate.getDate(),
    23,
    59,
    59
  );
  const remainingTimeToday = endOfDay.getTime() - currentDate.getTime();
  const hourstoday = Math.floor(
    (remainingTimeToday % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
  );
  console.log("endOfDay", endOfDay);
  console.log("remainingTimeToday", remainingTimeToday);

  // Convert remaining milliseconds to days, hours, minutes, and seconds
  const days = Math.floor(remainingTime / (1000 * 60 * 60 * 24));
  console.log("days", days);
  const hours = Math.floor(
    (remainingTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
  );
  console.log("hours", hours);
  const minutes = Math.floor((remainingTime % (1000 * 60 * 60)) / (1000 * 60));
  console.log("minutes", minutes);
  const seconds = Math.floor((remainingTime % (1000 * 60)) / 1000);
  console.log("seconds", seconds);

  const [isImage1Loaded, setIsImage1Loaded] = useState(false);
  const [isImage2Loaded, setIsImage2Loaded] = useState(false);
  const [isImage3Loaded, setIsImage3Loaded] = useState(false);
  const [isImage4Loaded, setIsImage4Loaded] = useState(false);

  return (
    <div
      className="content-body p-0"
      style={{ minHeight: window.screen.height - 100, overflow: "hidden" }}
    >
      <div className={classes.container}>
        <div className={classes.countdownContainer}>
          <div className="row mt-2 justify-content-md-center p-3 pb-0">
            <div className="col-lg-12 col-12 col-md-12 ">
              <div className="card p-3 feature-box pull-up m-0">
                <div className="card-header text-center p-0 flex-wrap">
                  <h1>Series II Launch</h1>
                </div>
                <div className="card-body">
                  {/* <Typography
                    variant="h4"
                    className={classes.countdownText}
                    style={{ color: "white" }}
                  >
                    Series Two Starts In:
                  </Typography> */}
                  <div className={classes.countdownTimer}>
                    {/* Days Countdown */}
                    <div className={classes.countdownCircle + " m-2"}>
                      <CountdownCircleTimer
                        isPlaying
                        duration={24 * 60 * 60}
                        initialRemainingTime={
                          hours * 60 * 60 + minutes * 60 + seconds
                        }
                        colors={[["#ffa817"]]}
                        size={100}
                        strokeWidth={8}
                        onComplete={() =>
                          console.log("Days countdown completed!")
                        }
                      >
                        {({ remainingTime }) => (
                          <Typography
                            variant="h5"
                            style={{ fontWeight: "bold", color: "#1a237e" }}
                          >
                            {days}d
                          </Typography>
                        )}
                      </CountdownCircleTimer>
                      <Typography variant="body1">Days</Typography>
                    </div>

                    {/* Hours Countdown */}
                    <div className={classes.countdownCircle + " m-2"}>
                      <CountdownCircleTimer
                        isPlaying
                        duration={60 * 60}
                        initialRemainingTime={
                          hours * 60 * 60 + minutes * 60 + seconds
                        }
                        colors={[["#ffa817"]]}
                        size={100}
                        strokeWidth={8}
                        onComplete={() =>
                          console.log("Hours countdown completed!")
                        }
                      >
                        {({ remainingTime }) => (
                          <Typography
                            variant="h5"
                            style={{ fontWeight: "bold", color: "#1a237e" }}
                          >
                            {hours}h
                          </Typography>
                        )}
                      </CountdownCircleTimer>
                      <Typography variant="body1">Hours</Typography>
                    </div>

                    {/* Minutes Countdown */}
                    <div className={classes.countdownCircle + " m-2"}>
                      <CountdownCircleTimer
                        isPlaying
                        duration={60}
                        initialRemainingTime={minutes * 60 + seconds}
                        colors={[["#ffa817"]]}
                        size={100}
                        strokeWidth={8}
                        onComplete={() =>
                          console.log("Minutes countdown completed!")
                        }
                      >
                        {({ remainingTime }) => (
                          <Typography
                            variant="h5"
                            style={{ fontWeight: "bold", color: "#1a237e" }}
                          >
                            {Math.floor(remainingTime / 60)}m <br />
                            {remainingTime % 60}s
                          </Typography>
                        )}
                      </CountdownCircleTimer>
                      <Typography variant="body1">Minutes</Typography>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row justify-content-md-center p-3 pt-0">
            <div className="col-lg-12 col-12 col-md-12 ">
              <div className="card p-3 feature-box pull-up m-0 pt-0">
                <div className="card-body">
                  <div className="row mt-3 mb-3">
                    <div className="col-6">
                      {/* Placeholder for Image 1 */}
                      {!isImage1Loaded ?? (
                        <Skeleton variant="rect" width="90%" height={200} />
                      )}
                      <img
                        src="https://app.croesus-asset.management/images/SeriesIIIcon1.jpg"
                        style={{ width: "90%", borderRadius: "0.625rem" }}
                        alt="Image 1"
                        onLoad={() => setIsImage1Loaded(true)}
                      ></img>
                    </div>
                    <div className="col-6">
                      {/* Placeholder for Image 2 */}
                      {!isImage2Loaded ?? (
                        <Skeleton variant="rect" width="90%" height={200} />
                      )}
                      <img
                        src="https://app.croesus-asset.management/images/SeriesIIIcon2.jpg"
                        style={{ width: "90%", borderRadius: "0.625rem" }}
                        alt="Image 2"
                        onLoad={() => setIsImage2Loaded(true)}
                      ></img>
                    </div>
                  </div>
                  <div className="row mt-3 mb-3">
                    <div className="col-6">
                      {/* Placeholder for Image 3 */}
                      {!isImage3Loaded ?? (
                        <Skeleton variant="rect" width="90%" height={200} />
                      )}
                      <img
                        src="https://app.croesus-asset.management/images/SeriesIIIcon3.jpg"
                        style={{ width: "90%", borderRadius: "0.625rem" }}
                        alt="Image 3"
                        onLoad={() => setIsImage3Loaded(true)}
                      ></img>
                    </div>
                    <div className="col-6">
                      {/* Placeholder for Image 4 */}
                      {!isImage4Loaded ?? (
                        <Skeleton variant="rect" width="90%" height={200} />
                      )}
                      <img
                        src="https://app.croesus-asset.management/images/SeriesIIIcon4.jpg"
                        style={{ width: "90%", borderRadius: "0.625rem" }}
                        alt="Image 4"
                        onLoad={() => setIsImage4Loaded(true)}
                      ></img>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SeriesTwo;
